import React from 'react';
import { inject, observer } from 'mobx-react';
import {
  Modal, Button, Spin, Row, Col
} from 'antd';
const store = ['appOrderStore'];
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'order-app-modal',
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible || false,
    }
  }
  componentWillReceiveProps(nextProps) {
    const { visible } = this.props;
    if (nextProps.visible && nextProps.visible !== visible) {
      this.setState({ visible: nextProps.visible });
    }
  }
  onCancel = () => {
    const { onCancel } = this.props;
    this.setState({ visible: false }, () => {
      onCancel && onCancel(false);
    });
  }
  render() {
    const { visible } = this.state;
    const { loading, datas, prefixCls } = this.props;
    const showName = datas && datas.sNumber && datas.sNumber.split(',').length === 1;
    return (
      <Modal
        title="应用获取"
        className={prefixCls}
        visible={visible}
        onCancel={this.onCancel}
        bodyStyle={{ height: 150 }}
        footer={[
          (<Button onClick={this.onCancel} key={`${prefixCls}cancel`}>返回</Button>)
        ]}
      >
        <div className={`${prefixCls}-body`}>
          <Spin spinning={loading}>
            <Row className={`${prefixCls}-body-row`}>
              <Col span={6}>获取应用：</Col>
              <Col span={18}>{datas && datas.sNumber}&nbsp;&nbsp;&nbsp;&nbsp;{showName && datas && datas.sName}</Col>
            </Row>
            <Row className={`${prefixCls}-body-row`}>
              <Col span={6}>下载地址：</Col>
              {
                datas && (
                  <Col span={18}>
                    <div className='app-apply-list-name'>
                      {
                        datas.url4All ? (
                          <a href={`${window.server}${datas.url4All}`}>完整包（云商店客户端 + 应用 + 授权文件）</a>
                        ) : datas.url4App ? (
                          <a href={`${window.server}${datas.url4All}`}>应用包</a>
                        ) : null
                      }
                    </div>
                    {
                      datas.url4App && (<div className='app-apply-list-name'><a href={`${window.server}${datas.url4App}`}>应用包（应用 + 授权文件）</a></div>)
                    }
                    {
                      datas.url4Key && (<div className='app-apply-list-name'><a href={`${window.server}${datas.url4Key}`}>授权包（仅授权文件）</a></div>)
                    }
                  </Col>
                )
              }
            </Row>
          </Spin>
        </div>
      </Modal>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/order/AppApplyModal.js